module.exports = __webpack_public_path__ + "img/7de19e1.png";